import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../../configs/MSAL.config";
import { createAxiosInstance } from "../../utils/axios-instance";

// A mock function to mimic making an async request for data
export async function useFetchUser() {
    const msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);
    const axiosInstance = createAxiosInstance(msalInstance);
    return axiosInstance.get(process.env.REACT_APP_API_ENDPOINT + 'compliance/user');
}
  